import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent
} from '@mui/material';
import {
  Email,
  Twitter,
  Chat
} from '@mui/icons-material';
import styled from 'styled-components';

const Section = styled(Box)`
  padding: 3rem 0;
`;

const ContactCard = styled(Card)`
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-4px);
  }
`;

const IconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.palette.primary.main};
  svg {
    margin-right: 0.5rem;
    font-size: 1.5rem;
  }
`;

const Contact: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Section>
        <Typography variant="h3" align="center" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="subtitle1" align="center" color="textSecondary" gutterBottom>
          We're here to help! Reach out to us through any of these channels.
        </Typography>

        <Grid container spacing={4} sx={{ mt: 4 }} justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <ContactCard>
              <CardContent>
                <IconWrapper>
                  <Email />
                  <Typography variant="h6">Email</Typography>
                </IconWrapper>
                <Typography variant="body2" color="textSecondary">
                  hello@xch.live
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  24/7 Support
                </Typography>
              </CardContent>
            </ContactCard>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <ContactCard>
              <CardContent>
                <IconWrapper>
                  <Chat />
                  <Typography variant="h6">Discord</Typography>
                </IconWrapper>
                <Typography variant="body2" color="textSecondary">
                  Join our community
                </Typography>
                <Typography variant="body2" color="textSecondary" component="a" href="https://discord.com/invite/Bb4sj3Bg9P" target="_blank" sx={{ textDecoration: 'none' }}>
                  discord.gg/Bb4sj3Bg9P
                </Typography>
              </CardContent>
            </ContactCard>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <ContactCard>
              <CardContent>
                <IconWrapper>
                  <Twitter />
                  <Typography variant="h6">Twitter</Typography>
                </IconWrapper>
                <Typography variant="body2" color="textSecondary">
                  Follow us for updates
                </Typography>
                <Typography variant="body2" color="textSecondary" component="a" href="https://x.com/xchlive" target="_blank" sx={{ textDecoration: 'none' }}>
                  @xchlive
                </Typography>
              </CardContent>
            </ContactCard>
          </Grid>
        </Grid>
      </Section>
    </Container>
  );
};

export default Contact; 